<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/out/order/detail/page"
        getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <div
            style="margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{$t('chukudantouxinxi')}}
        </div>
        <el-form :inline="true" ref="form" size="mini" :label-width="yt.formLabelWidth" style="margin-left: 100px">
<!--          {{$attrs.check}}-->
          <el-form-item class="noborder" :label="$t('danjuleixing')" required>
            <el-select disabled v-model="$attrs.check.type" @change="$forceUpdate()">
              <el-option :label="$t('chengpinchuku')" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chukudanhao')">
            <el-input disabled v-model="$attrs.check.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('kehumingcheng')">
            <el-input disabled v-model="$attrs.check.wmsCustomer==null?'':$attrs.check.wmsCustomer.name"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('danjuriqi')" required>
            <el-date-picker
                v-model="$attrs.check.billDate"
                type="date"
                value-format="timestamp"
                format="yyyy-MM-dd"
                disabled
            ></el-date-picker>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('beizhu')">
            <el-input disabled v-model="$attrs.check.remark"></el-input>
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 明细状态 -->
      <template #mingxizhuangtai="scope">
        <span v-if="scope.row.status===0">{{$t('weichuku')}}</span>
        <span v-if="scope.row.status===1">{{$t('bufenchuku')}}</span>
        <span v-if="scope.row.status===2">{{$t('quanbuchuku')}}</span>
      </template>
      <template #wuliaobianmamingcheng="scope">
        <span>{{scope.row.material.code}}/{{scope.row.material.name}}</span>
      </template>
      <template #danwei="scope">
        {{$t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.unit])}}
      </template>
      <!-- 左侧按钮插槽 -->
      <template #buttonsL>
        <div
            style="margin-bottom: 16px;color: #303133;font-weight: bold;font-size: 16px">
          {{$t('chukudanmingxixinxi')}}
        </div>
      </template>
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status===0||scope.row.status===1">
            <el-button type="text" @click="yt.showEditDialog('chuku', scope.row,'w2');getPlanCode()">{{$t('chuku')}}
            </el-button>
          </el-col>
          <!-- 撤销入库 -->
          <el-col :span="0.1" v-if="scope.row.status === 2 || scope.row.status === 1">
            <el-popconfirm title="是否确认撤销当前记录?" confirm-button-text="是" cancelButtonText="否" @confirm="reverseSendOut(scope.row)" v-if="utils.checkPower('web_wms_out_order_product_reverseSendOut')"  v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: { 's1': '成品出库-撤销出库' } }">
              <el-button type="text" slot="reference" style="color: #f67171;">
                {{$t('chexiao')}}
              </el-button>
            </el-popconfirm>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog"
        :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!-- 新增 -->
      <template v-if="yt.editObj.action == 'chuku'">
        <div class="dialog-scroller">
          <outbound_order ref="outboundAdd" :outbound="yt.editObj"></outbound_order>
        </div>

        <span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="yt.isShowEditDialog = false">{{$t('quxiao')}}</el-button>
					<el-button size="mini" :loading="yt.editObj.loading"
              @click="submitOutbound" type="primary">
						{{$t('baocun')}}
					</el-button>
				</span>
      </template>
      <!-- 编辑 -->

    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import outbound_order from '@@/pages/web/wms/out_order_product/check/outbound_order'
export default {
  name: 'web_wms_out_order_product_check_list',
  components: {
    outbound_order
  },
  data() {
    return {
      planCodeList: [],
      show: false,
      exceptionTypeList: [],
      columns: [{
        label: 'wuliaobianmamingcheng',
        prop: 'material.name',
        type: 'slot',
        // width: 150,
      }, {
        label: 'chanpinpicihao',
        prop: 'materialBatchNo',
        width: 130,
      }, {
        label: 'shengchangongdanhao',
        prop: 'woNo',
        width: 130,
      },  {
        label: 'danwei',
        prop: 'unit',
        type: 'slot',
        width: 130,
      }, {
        label: 'chukushuliang',
        prop: 'quantity',
        width: 130,
      }, {
        label: 'mingxizhuangtai',
        prop: 'status',
        type: 'slot',
        width: 130,
      }, {
        label: 'shichushuliang',
        prop: 'actualQuantity',
        width: 130,
      },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 180,
        },

        {
          label: 'caozuo',
          type: 'slot',
          width: 150,
          fixed: 'right'
        }
      ]
    };
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        outOrderId: this.$attrs.check.id,
      }
      this.yt.get(1);
    }, 300)
  },

  methods: {
    submitOutbound() {

      const res = this.$refs['outboundAdd'].$refs['form'].validate(valid => {
        // if (!valid) {
        //   return false
        // }

        let form = this.$refs['outboundAdd'].form
        // for (let i = 0; i < form['materialInventoryList'].length; i++) {
        //   form['materialInventoryList'][i]['newTransactionQuantity'] = (form['materialInventoryList'][i]['newTransactionQuantity'])
        // }
        return this.http.post('/web/out/order/detail/sendOut', form).then(response => {
          this.yt.get(1)
          this.yt.isShowEditDialog = false;
          this.$message.success(this.$t(response.msg))
        }).catch(error => {
          this.$message.error(error)
        })

      })
    },
    setDefaultValue() {
      this.yt.editObj.samplingType = 1;
      this.yt.editObj.enabled = true
    },
    reverseSendOut(data) {
      this.http
        .post('/web/out/order/detail/reverseSendOut', data)
        .then(res => {
          this.$message({
            message: this.$t('success'),
            type: 'success'
          });
          this.yt.get(1);
        })
        .catch(error => {
          this.$message.error(this.$t(error));
        });
    },

  }
};
</script>
